export const ContactInfoColumns = [
  "contactPoint.id",
  "contactPoint.fn",
  "contactPoint.hasEmail",
  "contactPoint.hasURL",
];
